import { useEffect } from "react";
import "../Css/Home.css";
import SlideBars from "./Components/SlidBars";
export default function Home() {
  useEffect(() => {
    const page = document.getElementById("HomeContent");
    if (page) page.style.animation = "fading  1s ";
  }, []);
  return (
    <div className="HomePage">
      <div id="HomeContent">
        <p>
          Hi there, <br /> I'm Vivek Jagtap
        </p>
        <br />
        <p>
          Developer and Automation Tester <br />
          at
          <br /> Tata Consultancy Services
        </p>
        <div className="desc">
          Looking For The Job Opportunity <br />
          as
          <br /> Software ,Web Developer{" "}
        </div>
        <br />
        <SlideBars />
      </div>
    </div>
  );
}
